import React from 'react';
import { useRotaForm } from '../context/RotaContext';
import { FaCalendarAlt, FaCopy } from 'react-icons/fa';

const Step1Details = () => {
  const { formData, updateField } = useRotaForm();

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-8 h-8 rounded-md bg-blue-600 flex items-center justify-center text-white font-bold">1</div>
        <h2 className="text-lg font-semibold text-gray-900">Rota Details</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Rota Name *</label>
          <input 
            type="text" 
            placeholder="e.g. May 2026 - Main Kitchen" 
            className="w-full text-sm p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
            value={formData.rotaName}
            onChange={(e) => updateField('rotaName', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Location *</label>
          <select 
            className="w-full text-sm p-2 border border-gray-300 rounded-md bg-white focus:outline-none"
            value={formData.location}
            onChange={(e) => updateField('location', e.target.value)}
          >
            <option>Sunset Restaurant</option>
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Period *</label>
          <input 
            type="date" 
            className="w-full text-sm p-2 border border-gray-300 rounded-md focus:outline-none"
            value={formData.startDate}
            onChange={(e) => updateField('startDate', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Rota Type</label>
          <select 
            className="w-full text-sm p-2 border border-gray-300 rounded-md bg-white focus:outline-none"
            value={formData.rotaType}
            onChange={(e) => updateField('rotaType', e.target.value)}
          >
            <option>Standard</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Working Pattern</label>
          <select className="w-full text-sm p-2 border border-gray-300 rounded-md bg-white focus:outline-none">
            <option value="">Select pattern</option>
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Notes (Optional)</label>
          <textarea 
            rows={1}
            placeholder="e.g. holiday cover, bank holiday, special events..." 
            className="w-full text-sm p-2 border border-gray-300 rounded-md focus:outline-none"
            value={formData.notes}
            onChange={(e) => updateField('notes', e.target.value)}
          />
        </div>
      </div>

      <div className="mt-4 flex justify-end">
        <button type="button" className="flex items-center gap-2 text-sm text-blue-600 font-medium hover:underline">
          <FaCopy /> Copy Last Month's Rota
        </button>
      </div>
    </div>
  );
};

export default Step1Details;
